import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=7cc58d39"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cc58d39')) {
      api.createRecord('7cc58d39', component.options)
    } else {
      api.reload('7cc58d39', component.options)
    }
    module.hot.accept("./dialog.vue?vue&type=template&id=7cc58d39", function () {
      api.rerender('7cc58d39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/send-list-conversation/add-item/dialog.vue"
export default component.exports